import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const calendarV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Setting correct foreground for appointment palettes',
  run: (props: PartialPropsOf<'calendar'>): void => {
    props.version ??= 1;
    if (props.version < 2) {
      const palette = props.style?.appointments?.palette;
      if (palette?.paletteName?.startsWith('palette')) {
        palette.foreground = `$t.palettes.${palette.paletteName}.fg`;
      }
      props.version = 2;
    }
  },
};
